import {
  default as React,
  FunctionComponent,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cn from 'classnames'
import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import ModalWrapper from '../components/Modal/ModalWrapper'
import Button from '../components/Button'
import CrossIcon from '../icons/cross.svg'
import EnvelopeUnread from '../icons/envelope_unread.svg'
import EnvelopeRead from '../icons/envelope_read.svg'
import { requestPublishedMessage, markMessageAsRead } from './messagesActions'
import { messageSelector } from './messagesSelectors'

const MessageIndicator: FunctionComponent = () => {
  const dispatch = useDispatch()
  const message = useSelector(messageSelector)
  const [opened, setOpened] = useState(false)

  const unread = useMemo(() => !!(message && message.read === false), [message])
  const isLong = useMemo(
    () => !!message && message.content.length > 800,
    [message],
  )
  const formattedDate = useMemo(
    () =>
      message
        ? new Date(message.publishedAt)
            .toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
            })
            .toUpperCase()
        : '',
    [message],
  )

  useEffect(() => {
    dispatch(requestPublishedMessage())
  }, [dispatch])

  const onOpen = () => {
    if (message && message.read === false) {
      dispatch(markMessageAsRead(message.id))
    }
    setOpened(true)
  }

  const onClose = () => {
    setOpened(false)
  }

  if (!message) return null

  return (
    <>
      <button
        className="clear-button"
        aria-label="Messages"
        onClick={onOpen}
        title="Message from Forshaw"
      >
        {unread ? <EnvelopeUnread /> : <EnvelopeRead />}
      </button>

      {opened && (
        <ModalWrapper className="import">
          <button className="import_backdrop clear-button" onClick={onClose} />
          <div
            className={cn('import_dialog user-modal -message', {
              '-wide': isLong,
            })}
          >
            <div className="user-modal_title">Message</div>
            <CrossIcon className="user-modal_close" onClick={onClose} />
            <div className="user-modal_info">
              <div className="user-modal_message-date">{formattedDate}</div>
              <div className="user-modal_message-content">
                <ReactMarkdown
                  remarkPlugins={[remarkBreaks]}
                  components={{
                    a: ({ node, ...props }) => (
                      <a {...props} target="_blank" rel="noopener noreferrer" />
                    ),
                  }}
                >
                  {message.content}
                </ReactMarkdown>
              </div>
            </div>
            <Button block className="user-modal_close-button" onClick={onClose}>
              Close
            </Button>
          </div>
        </ModalWrapper>
      )}
    </>
  )
}

export default MessageIndicator
